import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import clsx from "clsx";
import AttributeIcon from "csi/middleware/attributes/AttributeIcon";
import { DragWrapper, useDndStore } from "designSystem/dnd/index";
import { FlexRowCenter, IconButton, ListItem, OverflowText } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { DND_TYPE } from "../CustomViewDialogStore";
import CustomViewAttribute from "./CustomViewAttribute";
import css from "./CustomViewAttributes.module.css";

interface AttributeListItemProps {
	/** attribute */
	attribute: CustomViewAttribute;
}

const AttributeListItemHoverIcon: FunctionComponent<AttributeListItemProps> = observer(function AttributeListItemHoverIcon({ attribute }) {
	const { attributeCheckIcon, attributeHoverReplaceIcon, attributeRemoveIcon } = css;
	
	return attribute.store.hasMinimumNumberOfSelections ?
		<CheckIcon className={clsx(attributeHoverReplaceIcon, attributeCheckIcon)} />
		:
		<RemoveIcon className={clsx(attributeHoverReplaceIcon, attributeRemoveIcon)} />;
});

const AttributeListItem: FunctionComponent<AttributeListItemProps> = observer(function AttributeListItem({ attribute }) {
	const { canAddToView, grouped, isHighlighted, onClickAddAttribute, onClickListItem, onClickRemoveAttribute, selected, spec } = attribute;
	const { name, key } = spec;

	return (
		<DragWrapper
			canDrag={canAddToView}
			data-csi-attribute={key}
			dragItem={attribute}
			dragType={DND_TYPE.CUSTOM_VIEW_SELECTED_ATTRIBUTE}
			isMultiSelect
			onClick={onClickListItem}
		>
			<ListItem className={clsx(css.containerAttribute, grouped && css.groupedAttribute, selected && css.selectedAttribute, isHighlighted && css.blueBackground)}>
				<FlexRowCenter gap={0.5} marginLeft={4}>
					<AttributeIcon spec={spec} />
				</FlexRowCenter>
				<OverflowText
					grow
					text={name}
					tooltipProps={{ placement: "right" }}
				/>
				<IconButton
					className={css.attributeActionIcon}
					design="iconOnly"
					disabled={!canAddToView && !selected}
					onClick={canAddToView && !selected ? onClickAddAttribute : onClickRemoveAttribute}
					tabIndex={-1}
				>
					<>
						{selected && (
							<>
								<CheckIcon className={css.attributeCheckIcon} />
								<AttributeListItemHoverIcon attribute={attribute} />
							</>
						)}
						{canAddToView &&
							<AddIcon className={clsx(css.attributeHoverReplaceIcon, css.attributeAddIcon)} />
						}
					</>
				</IconButton>
			</ListItem>
		</DragWrapper>
	);
});

export default AttributeListItem;